import { request } from '@lrp/api-client';
import { searchRequestToQueryObject } from '@/client/actions/searchRequestToQueryString';

interface SubscriptionPreferences {
  emailEnabled: boolean;
  pushEnabled: boolean;
}

const createSavedSearch = (
  xsrfToken: string,
  searchRequest: TSearchRequest,
  subscriptionPreferences: SubscriptionPreferences = {
    emailEnabled: true,
    pushEnabled: true,
  },
) =>
  request({
    uri: '/lrp/api/saved-searches',
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'x-mp-xsrf': xsrfToken, 'Content-Type': 'application/json' },
    body: JSON.stringify({
      ...searchRequestToQueryObject(searchRequest),
      subscriptionPreferences,
    }),
  }) as Promise<{ id: number }>;

export default createSavedSearch;
